var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-3"},[_c('Stepper',{attrs:{"active-step":"3"}}),(_vm.giftData.isGift)?_c('GiftDelivery'):_c('MailDelivery')],1)}
var staticRenderFns = []

export { render, staticRenderFns }